let selectedRadio;

// Retrieve the selected radio button on page load
window.addEventListener("load", function () {
  selectedRadio = localStorage.getItem("selectedRadio");
  if (selectedRadio !== null) {
    let radioButtons = document.querySelectorAll(
      "input[value='" + selectedRadio + "']"
    );
    radioButtons.forEach(function (radioButton) {
      radioButton.checked = true;
      optionToNote(radioButton.value);
    });
  }
});

// Function to pass Option to Cart note - called on radio button click
function optionToNote(option) {
  localStorage.setItem("selectedRadio", option)
  selectedRadio = localStorage.getItem("selectedRadio");

  // Conditional to display packaging value in note only if option 2
  selectedRadio === "option2" ? false : selectedRadio = "";
  appendOptionToNotes(selectedRadio);
}

const appendOptionToNotes = async(option = "") => {
  // Based on Option2 value is stored in input
  let textareaElement = null;

  if (window.location.href.includes("/cart")) {
    textareaElement = document.getElementById("CartNote");
  } else {
    textareaElement = document.getElementById("CartNoteDrawer");
  }

  let notesArr = textareaElement.value.split(',').map((item) => { return item.trim() });

  if (option === "option2") {
    if (!textareaElement.value.includes(option)) {
      notesArr.push(option);
    }
  } else if (option === "") {
    notesArr = notesArr.filter((note) => {
      return !note.includes("option2");
    });
  }

  textareaElement.value = notesArr.join(', ');

  //let notes = await getNotes();
  //notes = notes.split(',')
  //notes = notes.filter((note)=>{
    //return !note?.toLowerCase().includes('option');
  //})

  //if (option !== "") {
    //notes.push(option);
  //}
  //return await addNotes(notes);
}

window.appendOptionToNotes = appendOptionToNotes

const getNotes = async() => {
  response = await fetch("/cart.js")
  let json = await response.json();
  return json.note;
}

const addNotes = async(notes) => {
  response = await fetch("/cart/update.json", {
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      method: "POST", body: JSON.stringify({"note": notes.join()}) })
  let cartJson = await response.json();
  return cartJson;
}

const getProductEngraving = product => {
  let engravingNotes = [];
  let result_engraving;
  let result_uploaded_img;
  if (product.properties !== null) {
    if (product.properties['ADD ENGRAVING'] && product.properties['ADD ENGRAVING'] !== '' ){
      result_engraving = product.sku + "-" + product.product_title + ":" + product.variant_title + ":EngravingText[" + product.properties['ADD ENGRAVING'] + "]";
      engravingNotes.push(result_engraving);
    } else {
      result_engraving = '';
    }

    if (product.properties['Photo Uploaded_1']|| product.properties['Photo Uploaded_1'] || product.properties['Single Image Upload'] || product.properties['Single Image Upload'] || product.properties['Photo Uploaded'] !== undefined || product.properties['Photo Uploaded'] ) {
      result_uploaded_img = 'Image Uploaded';
      engravingNotes.push(result_uploaded_img);
    } else {
      result_uploaded_img = '';
    }
    
    for (let key in product.properties) {
      if (key.charAt(0) === '_' || !product.properties[key]) {
        delete product.properties[key];
      }
    }
    
  }

  return engravingNotes;
}

document.addEventListener("DOMContentLoaded", function() {
  var collapsibleTrigger = document.querySelectorAll('.drawer__inner .collapsible-trigger');

  for (var i = 0; i < collapsibleTrigger.length; i++) {
    collapsibleTrigger[i].addEventListener('click', function() {
      var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
      drawerInner.classList.toggle('current');
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var collapsibleTrigger = document.querySelectorAll('.drawer__inner .collapsible-trigger');

  for (var i = 0; i < collapsibleTrigger.length; i++) {
    collapsibleTrigger[i].addEventListener('click', function() {
      var drawerInner = document.querySelector('.template-cart .main-cart_wrapper');
      drawerInner.classList.toggle('current');
    });
  }
});
